/* eslint-disable react/no-unescaped-entities */

"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { motion } from "motion/react";

import { SiteFooter } from "@/components/SiteFooter";
import { SiteHeader } from "@/components/SiteHeader";

import styles from "./state.module.css";

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      router.replace("/");
    }, 4000);

    return () => window.clearTimeout(timer);
  }, [router]);

  return (
    <>
      <SiteHeader />
      <div className={`${styles.screen} ${styles.screenWithSiteChrome}`}>
        <motion.div
          className={styles.card}
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.32, ease: "easeOut" }}
        >
          <span className={styles.eyebrow}>
            <i className="bi bi-signpost-split"></i>
            Erreur 404
          </span>

          <h1 className={styles.title}>Cette page n'existe pas ou a peut-être été déplacée.</h1>
          <p className={styles.text}>
            Redirection automatique vers l'accueil dans quelques secondes.
          </p>

          <div className={styles.actions}>
            <Link href="/" className={styles.actionPrimary}>
              Retour a l'accueil
            </Link>
            <Link href="/purchase" className={styles.actionSecondary}>
              Aller vers l'achat
            </Link>
          </div>
        </motion.div>
      </div>
      <SiteFooter />
    </>
  );
}
